import forOneApp from '../../hoc/for-one-app';
import CategoriesLink from './change-category';
import CategorySelect from './change-category-one-app';

export default forOneApp(CategorySelect, CategoriesLink);
